import React, { Component } from 'react';
import Modal from '../components/Modal';
import StagesManager from '../components/StagesManager';
import ButtonAnimated from '../components/buttons/ButtonAnimated';
import FixedView from '../components/FixedView';
import { checkTranslation, translate } from '../utils/useful';
import FormViewer from '../components/FormViewer';
import { siteConfig } from '../variables/config';
import { QRCode } from 'react-qrcode-logo';
import TextAreaInput from '../components/inputs/TextAreaInput';
import HttpServices from '../utils/Http.services';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../stores/actionsList';
import CustomLoader from '../components/CustomLoader';
import HubsAndGroupsInput from '../components/inputs/HubsAndGroupsInput';

class ShareModal extends Component {

    state = {
        accessTypes: [
            { key: 'frameAccess', title: '{{lang}}Frame access ', access: '{{lang}}can view', icon: '/assets/icons/useful/key-access.png', description: 'Access will be limited based on the frame permissions and access.' },
            { key: 'frameAndExtra', title: '{{lang}}Frame access + extra access', access: '{{lang}}can view', icon: '/assets/icons/useful/people.png', description: 'Access will be limited based on the frame permissions and some extra specific hubs, people, and/or groups.' },
            { key: 'restricted', title: '{{lang}}Restricted ', access: '', icon: '/assets/icons/useful/people.png', description: "Only specific hubs and/or groups can have access." },
            { key: 'link', title: '{{lang}}Anyone with link ', access: '', icon: '/assets/icons/useful/link.png', description: "Anyone with link can have access." },

        ],
        // accessTypes: [
        //     // { key: 'collaborators', title: '{{lang}}Only collaborators of the document can access via link', icon: '/assets/icons/applets/drive/2peoples.svg', },
        //     // { key: 'organizationView', title: '{{lang}}People in the organization with the link ', access: '{{lang}}can view', icon: '/assets/icons/applets/drive/organization.svg', },
        //     // { key: 'organizationEdit', title: '{{lang}}People in the organization with the link ', access: '{{lang}}can edit', icon: '/assets/icons/applets/drive/organization.svg', },
        //     { key: 'frameAccess', title: '{{lang}}Anyone with Applet Access ', access: '{{lang}}can view', icon: '/assets/icons/applets/drive/earth.svg', },
        //     { key: 'restricted', title: '{{lang}}Restricted ', access: '', icon: '/assets/icons/applets/drive/earth.svg', },
        //     // { key: 'AnyoneEdit', title: '{{lang}}Anyone with the link ', access: '{{lang}}can edit', icon: '/assets/icons/applets/drive/earth.svg', },
        // ],
        currentShare: 0,
        headers: [
            { type: 'HubsAndGroupsInput', key: 'allowed', information: { address: 'searchUser', filter: {}, helperKey: 'hub._id', fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Add Users', required: false, } },
        ],
        headersLink: [
            { type: 'GlobalUserMultiInput', key: 'link', information: { address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Add Users', required: false, } },
            { type: 'SelectInput', key: 'applet', information: { isSearchable: true, label: '{{lang}}Applet', address: 'getMyFramesByType', filter: { features: 'Drive' }, fields: { title: 'applet.name', value: '_id' }, type: 'api', root: null, placeholder: '{{lang}}Select applet', required: false } },
        ],
        headersNotif: [
            { type: 'TextAreaInput', key: 'notif', information: { placeholder: '{{lang}}Add a note (Message will be sent to Yonnect messenger)', required: false, disabled: false } },
        ],
        qrCodeLink: '',
        link: '',
        showYonnect: false,
        showQRCode: false,
        notif: true
    }

    componentDidMount() {
        // console.log('mylink',this.props.currentItem)
        // this.props.setLink(this.props.currentItem)
    }


    // componentDidUpdate(prevProps) {
    //     if (this.props.currentItem && JSON.stringify(this.props.currentItem) != JSON.stringify(prevProps.currentItem)) {

    //         this.init()
    //     }
    // }

    showModal = () => {
        this.modal.showModal()
        this.init()

    }

    init = () => {
        // console.log(this.props.variables)
        // console.log('this.props.currentItem.allowed', this.props.currentItem)
        let _id = this.props.currentItem?._id

        if (_id) {
            this.setState({ isLoadingGet: true })
            HttpServices.request('getDriveAccess', { _id }, (fetchResult, fetchError) => {

                this.setState({ isLoadingGet: false })
                // console.log(fetchResult, fetchError)
                if (fetchError) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                    return
                }

                let accessTypes = this.state.accessTypes
                let access

                if (fetchResult.info?.access && typeof fetchResult.info?.access == 'string') {
                    accessTypes.forEach(element => {
                        if (element.key == fetchResult.info?.access) {
                            access = element
                        }
                    });
                }

                if (!access) {
                    access = accessTypes[0]
                }
                // console.log(access)

                this.setState({ accessType: access, allowed: fetchResult.info?.allowed })
                // console.log('fetchResult.info', fetchResult.info)
                // this.props.updateFile(fetchResult.info)
                // this.modal.hideModal()
            })

        }
        // let currentShare
        // if (this.props.currentItem?.settings?.access) {
        //     this.state.accessTypes.map((element, index) => {
        //         if (element.key == this.props.currentItem?.settings?.access) {
        //             currentShare = index
        //         }
        //     })
        // }
        // else {
        //     currentShare = 0
        // }
        // this.setState({ currentShare })
    }


    // shareModal = () => {
    //     this.modal.showModal();
    // }

    changeAccessType = (item, index) => {
        // let currentShare = this.state.currentShare
        // currentShare = index
        this.setState({ accessType: item })
    }

    info = (text) => {
        return (
            <div className='br-4 px-2 py-1' style={{ position: 'absolute', top: -28, backgroundColor: 'rgb(0, 0, 0, 0.8)' }}>
                <p className='font-size-12' style={{ color: '#fff', whiteSpace: 'nowrap' }}>{text}</p>
            </div>
        )
    }
    setAccess = () => {
        // console.log('wwq', this.form1.getForm())

        // let body = this.form1.getForm() ?? {}
        let body = {}
        body._id = this.props.currentItem._id
        // body.applet = this.props.currentApplet?._id ?? this.props.currentApplet
        // if (body.applet == '') {
        //     body.applet = this.props.applet?._id ?? this.props.applet
        // }
        body.access = this.state.accessType.key
        body.allowed = this.state.allowed

        // console.log('bodyiiss', body)
        this.setState({ isLoadingPost: true })
        // return
        HttpServices.request('setDriveAccess', body, (fetchResult, fetchError) => {

            this.setState({ isLoadingPost: false })
            console.log(fetchResult, fetchError)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postedSuccesfully', description: '{{lang}}info.dataPostedSuccessfully' })

            // console.log('fetchResult.info', fetchResult.info)
            this.props.updateFile(fetchResult.info)
            this.modal.hideModal()

        })
    }
    setNotif = () => {
        let notif = this.state.notif
        let headersNotif = this.state.headersNotif
        this.setState({ notif: !notif }, () => {
            if (this.state.notif) {
                headersNotif[0].information.disabled = false
            }
            else {
                headersNotif[0].information.disabled = true
            }
            this.setState({ headersNotif })
        })

    }


    allowedChangeValue = (key, value, extra) => {

        this.setState({ allowed: value })

    }



    render() {
        let { currentShare } = this.state
        return (
            <Modal maxWidth={400} ref={(el) => this.modal = el} zIndex={10} lockOverlay={true}>




                <div className="shareModal d-flex flex-column w-100 window-content-radius ">
                    <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}  >
                        <div className="px-3 py-2" stage={0} stageName={'share'}>
                            <div className="pb-2" style={{ borderBottom: '1px solid #f0f0f0' }}>
                                {/* {console.log('this.props.currentItemthis.props.currentItem', this.props.currentItem)} */}
                                <p className="font-size-14 weight-600">{translate('Manage access')}</p>
                                <p className="font-size-12 weight-400">{this.props.currentItem?.name}{this.props.currentItem?.extension ? '.' + this.props.currentItem?.extension : ''}</p>
                            </div>

                            {this.state.isLoadingGet && (
                                <div className="py-4 flexcc">
                                    <CustomLoader isLoading={true} />
                                </div>
                            )}
                            {!this.state.isLoadingGet && this.state.accessType && (
                                <>
                                    <div className="py-2">
                                        <p className="font-size-14  text-bold" >{translate('Access type')}</p>
                                    </div>
                                    <div className="d-flex flex-row flexc pb-3">
                                        <div className="p-1 flexcc mrd-2" style={{ background: '#ddd', borderRadius: '100px' }}>
                                            <img src={this.state.accessType?.icon} className="p-1" width={25} style={{}} />
                                        </div>
                                        <div className='w-100'>
                                            <button className="flexcb shareLockButton p-1 px-2 w-100" ref={(el) => (this.currentNode = el)} onClick={() => this.fixedView.showView()}>
                                                <div className='w-100 text-start'>
                                                    <p className="mrd-2 font-size-14 weight-600">{checkTranslation(this.state.accessType?.title)}</p>
                                                    <p className="mrd-2 font-size-12 weight-500">{translate(this.state.accessType?.description)}</p>
                                                </div>
                                                {/* <span className='weight-600'>{checkTranslation(this.state.accessType?.access)}</span> */}
                                                <img width={20} src="/assets/icons/applets/drive/arrow-up-white.svg" className="invert" alt="" style={{ transform: 'rotate(180deg)' }} />
                                            </button>
                                        </div>
                                    </div>


                                    {(this.state.accessType?.key != 'frameAccess' && this.state.accessType?.key != 'link') && (

                                        <div className="pb-2 pt-2">

                                            <div className='flexcb mb-2'>
                                                <p className='font-size-14  text-bold'>{translate('Hub / groups with access')}</p>
                                                {/* <button className='flexc' onClick={() => { this.stageManager.changeStage('collaborators') }}>
                                            <img src='/images/profile-men-1.svg' className='br-50' width={20} />
                                            <img src='/assets/icons/angle-right.svg' width={20} />
                                        </button> */}
                                            </div>

                                            <div className='br-4 bordered-input flexc' >
                                                <HubsAndGroupsInput header={{ key: 'allowed', information: { address: 'searchUser', default: { hubs: [{ hub: this.props.currentItem?.creator, permissions: '*', }], groups: [] }, permissions: true, constants: [this.props.currentItem?.creator?._id], filter: {}, helperKey: 'hub._id', fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Add Users', required: false, } }} data={this.props.currentItem?.allowed} changeValue={this.allowedChangeValue} variables={this.props.variables} />
                                            </div>
                                            {/* <FormViewer initData={{ allowed: this.props.currentItem?.allowed }} ref={el => this.form1 = el} liveChange={this.allowedChangeValue} headers={this.state.headers} errors={this.state.errors} formClass={"bordered-form"} inputClass={'bordered-input'} nopadding={true} setData={this.props.setData} variables={this.props.variables} /> */}

                                        </div>
                                    )}

                                    <div className="flexcb" style={{ justifyContent: 'center' }}>
                                        <div className="flexcb w-100 pt-2" style={{}}>
                                            <div className='flexc'>
                                                <div className="flexc mrd-2">
                                                    <ButtonAnimated
                                                        iconwidth='24px'
                                                        onClick={() => { this.props.copyLink(this.props.currentItem) }}
                                                        title={translate('drives.Copy link')}
                                                        textColor={'#777'}
                                                        bg={'#eee'}
                                                    />
                                                </div>
                                                <button className='br-100 flexcc' style={{ position: 'relative', backgroundColor: '#eee', width: '34px', height: '34px' }} onMouseOver={() => this.setState({ showYonnect: true })} onMouseLeave={() => this.setState({ showYonnect: false })} onClick={() => { this.stageManager.changeStage('link'); this.setState({ showYonnect: false }) }}>
                                                    <img src='/assets/icons/portals/folder2.svg' width={24} height={24} alt='' />
                                                    {this.state.showYonnect &&
                                                        this.info('Yonnect messenger')
                                                    }
                                                </button>
                                                <button className='br-100 flexcc mld-2' style={{ position: 'relative', backgroundColor: '#eee', width: '34px', height: '34px' }} onMouseOver={() => this.setState({ showQRCode: true })} onMouseLeave={() => this.setState({ showQRCode: false })} onClick={() => { this.stageManager.changeStage('qrCode'); this.setState({ showQRCode: false }) }}>
                                                    <img src='/assets/icons/applets/drive/qr-code.svg' width={24} height={24} alt='' />
                                                    {this.state.showQRCode &&
                                                        this.info('QR code')
                                                    }
                                                </button>
                                            </div>
                                            <div className="flexc mld-2">
                                                <ButtonAnimated
                                                    iconwidth='24px'
                                                    onClick={() => (this.setAccess())}
                                                    title={translate('Submit')}
                                                    icon='/assets/icons/angle-right-white2.svg'
                                                    textColor={'#fff'}
                                                    isLoading={this.state.isLoadingPost}
                                                    bg={this.props.colors ? this.props.colors.background : '#c83418'}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                </>
                            )}
                        </div>
                        <div className="" stage={1} stageName={'collaborators'}>
                            <button className='flexc pt-3 px-3' onClick={() => { this.stageManager.changeStage('share') }}>
                                <img src='/assets/icons/angle-right.svg' style={{ transform: 'rotate(180deg)' }} width={20} alt='' />
                                <p className='font-size-15 weight-600 pld-2'>{translate('Manage collaborators')}</p>
                            </button>
                            <div className='pt-2 pb-3 px-3'>
                                <p className='font-size-13 main-c7'>{translate('People who can access this document')}</p>
                                <div className='pt-3 flexcb'>
                                    <div className='flexc'>
                                        <img src='/images/profile-men-1.svg' className='br-50' width={32} />
                                        <div className='pld-3'>
                                            <div className='flexc'>
                                                <p className='font-size-14 main-c2'>Parna Azizi</p>
                                                <p className='mld-2 px-2 py-1' style={{ background: '#5b65f533', color: '#4752e6', borderRadius: '4px', fontSize: '12px' }}>{translate('Owner')}</p>
                                            </div>
                                            <p className='font-size-13 main-c7'>{translate('No department info')}</p>
                                        </div>
                                    </div>
                                    <p className='font-size-15 main-c2'>{translate('Can manage')}</p>
                                </div>
                            </div>
                            <div className='px-2 py-2 px-3' style={{ borderTop: '1px solid #e5e5e5' }}>
                                <button className='flexc' onClick={() => { this.stageManager.changeStage('addCollaborators') }}>
                                    <p>{translate('Add collaborators')}</p>
                                </button>
                            </div>
                        </div>
                        <div className="" stage={2} stageName={'addCollaborators'}>
                            <button className='flexc pt-3 px-3' onClick={() => { this.stageManager.changeStage('collaborators') }}>
                                <img src='/assets/icons/angle-right.svg' style={{ transform: 'rotate(180deg)' }} width={20} />
                                <p className='font-size-15 weight-600 pld-2'>{translate('Manage collaborators')}</p>
                            </button>
                            <div className='pt-2 pb-3 px-3'>
                                <p className='font-size-13 main-c7'>{translate('People who can access this document')}</p>
                                <div className='pt-3 flexcb'>
                                    <div className='flexc'>
                                        <img src='/images/profile-men-1.svg' className='br-50' width={32} />
                                        <div className='pld-3'>
                                            <div className='flexc'>
                                                <p className='font-size-14 main-c2'>Parna Azizi</p>
                                                <p className='mld-2 px-2 py-1' style={{ background: '#5b65f533', color: '#4752e6', borderRadius: '4px', fontSize: '12px' }}>{translate('Owner')}</p>
                                            </div>
                                            <p className='font-size-13 main-c7'>{translate('No department info')}</p>
                                        </div>
                                    </div>
                                    <p className='font-size-15 main-c2'>{translate('Can manage')}</p>
                                </div>
                            </div>
                            <div className='px-2 py-2 px-3' style={{ borderTop: '1px solid #e5e5e5' }}>
                                <button className='flexc'>
                                    <p>{translate('Add collaborators')}</p>
                                </button>
                            </div>
                        </div>
                        <div className="" stage={3} stageName={'qrCode'}>

                            <div className='flexcb  pt-2 px-3 pb-2' style={{ borderBottom: '1px solid #eee' }}>
                                <button className='flexc' onClick={() => { this.stageManager.changeStage('share') }}>
                                    <img src='/assets/icons/angle-right.svg' style={{ transform: 'rotate(180deg)' }} width={20} />
                                    <p className='font-size-15 weight-600 pld-2'>{translate('QR Code')}</p>
                                </button>

                                <button className='text-link font-size-14' onClick={() => this.qrCode.download()}><p>{translate("Download")}</p></button>
                            </div>

                            <div className='pt-2 pb-3 px-3'>
                                <div className='w-100 h-100 flexcc'>
                                    <QRCode ref={el => this.qrCode = el} value={this.props.link} size="160" quietZone={10} logoImage={'/assets/logo-100.jpg'} removeQrCodeBehindLogo={true} logoWidth={24} qrStyle={'dots'} eyeRadius={[[10, 10, 10, 10], [10, 10, 10, 10], [10, 10, 10, 10],]} eyeColor={'#303030'} enableCORS={true} ecLevel="Q" />
                                </div>
                                <div className='flexcc  br-8 px-3 py-3' style={{ backgroundColor: '#f2f2f2' }}>
                                    <p className='font-size-14 ' style={{ color: '#777' }} >{translate('This QR code can be used for accessing this file. It can be shared with others.')}</p>
                                </div>
                                {/* <button onClick={()=>this.qrCode.download()}><p>{translate("Download")}</p></button> */}
                            </div>
                        </div>
                        <div className="" stage={4} stageName={'link'}>
                            <button className='flexc pt-3 px-3' onClick={() => { this.stageManager.changeStage('share') }}>
                                <img src='/assets/icons/angle-right.svg' style={{ transform: 'rotate(180deg)' }} width={20} />
                                <p className='font-size-15 weight-600 pld-2'>{translate('Invite by link')}</p>
                            </button>
                            <div className='pt-2 pb-3 px-3'>
                                <FormViewer ref={el => this.form2 = el} initData={this.props.data} data={this.props.data} headers={this.state.headersLink} errors={this.state.errors} inputClass={'modern-input'} nopadding={true} setData={this.props.setData} />
                                <div className='flexc'>
                                    <div className="br-6 flexcc mrd-2" style={{ border: this.props.colors ? `1px solid ${this.props.colors.primaryColor}` : '1px solid rgb(245, 139, 0)', backgroundColor: this.state.notif ? (this.props.colors ? this.props.colors.primaryColor : 'rgb(245, 139, 0)') : '', width: '20px', height: '20px', cursor: 'pointer' }} onClick={() => { this.setNotif() }}>
                                        {this.state.notif &&
                                            <img src='/assets/icons/applets/drive/tick.svg' width={'15px'} height={'15px'} />
                                        }
                                    </div>
                                    <p className='font-size-14 main-c2'>{translate('Send a notification')}</p>
                                </div>
                                <div className='pt-2'>
                                    <FormViewer ref={el => this.form3 = el} initData={this.props.data} data={this.props.data} headers={this.state.headersNotif} errors={this.state.errors} inputClass={'modern-input'} nopadding={true} setData={this.props.setData} />
                                </div>
                            </div>
                            <div className='py-2 px-3' style={{ borderTop: '1px solid #e5e5e5' }}>
                                <div className="flexc" style={{ justifyContent: 'flex-end' }}>
                                    <ButtonAnimated
                                        iconwidth='24px'
                                        onClick={() => (this.stageManager.changeStage('share'))}
                                        title={translate('Cancel')}
                                        textColor={'#a3a2b0'}
                                        bg={'#eee'}
                                    />
                                    <div className="flexc mld-2">
                                        <ButtonAnimated
                                            iconwidth='24px'
                                            onClick={() => { }}
                                            title={translate('Send')}
                                            icon='/assets/icons/angle-right-white2.svg'
                                            textColor={'#fff'}
                                            bg={this.props.colors ? this.props.colors.background : '#c83418'}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </StagesManager>
                </div>

                <FixedView ref={(el) => (this.fixedView = el)} nodeRef={this.currentNode} width={280} xOffset={0} topOffset={0} showFocus={false} zIndex={20} >
                    <div className='shadow-2 bg-white p-1 br-10 py-1' style={{}}>
                        {this.state.accessTypes.map((item, index) => {
                            return (
                                <button key={index} className="w-100 flexcc py-1 px-1 flex-column hover-fields-item" style={{ alignItems: "flex-start", }} onClick={() => { this.changeAccessType(item, index); this.fixedView.hideView() }}>
                                    <div className="flexc  w-100 px-1 py-1" style={{}}>

                                        {this.state.accessType?.key == item.key ? (
                                            <img src="/assets/icons/useful/checkmark.png" width={20} />
                                        ) : (
                                            <div style={{ width: 20 }}></div>
                                        )}
                                        <p className="text-bold font-size-14 mld-2">{checkTranslation(item.title)}</p>

                                    </div>
                                </button>
                            )
                        })}
                    </div>
                </FixedView>
            </Modal>
        );
    }
}

// export default ShareModal;

const mapStateToProps = state => ({ settings: state.settings, user: state.user, connections: state.connections })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(ShareModal);